window.Vue = require('vue');
//import $ from 'jquery';
import swal from 'sweetalert'
//window.$ = window.jQuery = $;
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import 'air-datepicker/dist/js/datepicker.min.js'
import 'air-datepicker/dist/css/datepicker.min.css'

import 'leaflet'
import 'leaflet.locatecontrol/dist/L.Control.Locate.min.js'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.min'
//import 'leaflet.markercluster'
import wait from './components/wait'
import qrcode from './qrcode'

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('D MMMM Y');
  }
});

//import 'jquery-google-sheet-to-json';

//import vue2vis from 'vue2vis';
//Vue.component('timeline', vue2vis.Timeline);

//window.axios = require('axios');
//window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

//Vue.component('spin', require('./components/spin.vue'));

/*Vue.filter('cifer', (val) => {
  return val.toLocaleString('ru');
});*/
//Vue.component('timeline-component', require('./components/timeline.vue'));

Vue.component('set-coord', require('./components/set-coord.vue').default);
Vue.component('show-coord', require('./components/show-coord.vue').default);
//Vue.component('account-login', require('./components/ei/account-login.vue'));

UIkit.use(Icons);


/* Yandex */
let Yacounter = {
  num: '51115889',
  goal: 'ZAYKA'
};

const app = new Vue({
  el: '#app',
  data: {
    loaded: false,
    qr: false,
    findActive: false,
    dates:{
      bd: '',
      dd: '',
    },
    modal: {
      title: "Заказать звонок",
      button: 'Отправить',
      theme: 'Заявка',
      vopr: false,
    },
    wait: false,
    confid: true,
    currentCity: {},
    selectCity: false,
    init: init
  },
  computed: {},
  methods: {

    setModal(title = 'Заявка', theme = 'Заявка', button = 'Отправить', vopr = false, bron = false) {
      let modal = {
        title,
        button,
        theme,
        vopr,
        bron
      };
      this.modal = modal;
      //console.log(modal);
    },
    counter() {
      if (typeof (window['yaCounter' + Yacounter.num]) !== "undefined") {
        console.log('Счетчик сработал');
        window['yaCounter' + Yacounter.num].reachGoal(Yacounter.goal);
      } else {
        console.log('Счетчик неопределен');
      }
    },
    sendForm(event) {
      let fd = {};
      let form = $(event.target);
      form.serializeArray().forEach(function (element) {
        fd[element.name] = element.value;
      });

      let app = this;
      let formdata = {
        form: fd
      };


      console.log(fd);
      $.request('onSend', {
        data: fd,
        success: function (data) {
          //... do something ...
          console.log(data);
          //this.success(data);
        },
        error: function (err) {
          console.log(err);
        }
      })

    },
    thanks() {
      UIkit.modal('#thanksmodal').show();
    },
    autoModal() {
      let app = this;
      $('.js-modal').on('click', function () {
        let text = $(this).text();
        let modal = {
          title: text,
          button: 'Отправить',
          theme: text
        };
        app.modal = modal;
        UIkit.modal('#ordermodal').show();
      });
    },
    openLightbox(el) {
      UIkit.lightbox(el).show();
    },
    makeQrCode(url) {
      console.log(url);
      if (!this.qr) {

        let typeNumber = 0;
        let errorCorrectionLevel = 'L';
        qrcode.stringToBytes = qrcode.stringToBytesFuncs['UTF-8'];
        let qr = qrcode(typeNumber, errorCorrectionLevel);
        qr.addData(url);
        qr.make();
        document.getElementById('qrcode').innerHTML = qr.createImgTag(8,4);

      }
    },
    ajaxes() {
      let app = this;
      $(window).on('ajaxBeforeSend', function() {
        app.wait = true;
        console.log('ajaxBeforeSend');
      });

      $(window).on('ajaxUpdateComplete', function(event, context, data) {
        app.wait = false;
        console.log('ajaxUpdateComplete');
        console.log(data);
        let status = 'success';
        if(data.message){
          if(typeof data.status !== "undefined"){
            status = data.status ? 'success' : 'error';
          }
          swal(data.message, "", status);
        }
      });

      $(window).on('ajaxError', function() {
        app.wait = false;
        console.log('ajaxError');
      });

      $(window).on('ajaxSuccess', function(event, context, data, status) {
        app.wait = false;
        console.log('ajaxSuccess');
        //console.log(event, context, data);
      });

      $(window).on('ajaxConfirmMessage', function(event, message) {
        // Stop the default confirm dialog
        //console.log(event, message);
        app.wait = false;
        console.log('ajaxConfirmMessage');
        event.preventDefault();

        swal({
          title: message,
          //text: "Once deleted, you will not be able to recover this imaginary file!",
          icon: "warning",
          buttons: ['Отмена', 'Да'],
          dangerMode: true,
        })
        .then((choise) => {
          //console.log(choise);
          if (choise) {
            event.promise.resolve();
          } else {
            event.promise.reject();
          }
        });

        return true;
      });

    },
    message(){
      if(this.init.message){
        swal(this.init.message, "", 'success');
      }
    },
    inits(){
      $('.js-dp').datepicker({
        dateFormat: 'dd-mm-yyyy',
      });
    },
    maps() {
      /* var map = L.map('mapid').setView([51.505, -0.09], 13);

       L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
         attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
       }).addTo(map);

       L.marker([51.5, -0.09]).addTo(map)
       .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
       .openPopup();*/
      let map = L.map('mapid').setView([55.79788757, 49.11057300], 18);

      L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
        maxZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }).addTo(map);

      L.marker([55.79788757, 49.11057300]).addTo(map)
      .bindPopup('Потолки Esthete')
      .openPopup();

      map.scrollWheelZoom.disable();
      /*

      map.on('click', function () {
        if (!map.scrollWheelZoom.enabled()) {
          map.scrollWheelZoom.enable();
        }
      });
      map.on('mouseout', function () {
        map.scrollWheelZoom.disable();
      });
      if ($(window).width() > 768) {
        map.panBy(new L.Point(-250, 0));
      } else {
        //map.panBy(new L.Point(-250, 0));
      }*/
    },

  },
  components: { DatePicker, wait },
  mounted() {
    this.inits();
    this.ajaxes();
    this.message();
    //this.maps();
    //this.autoModal();
  }
});